// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"f6f42385","960":"c93916db","983":"ed8109cc"}[chunkId] + ".chunk.css";
};